import {UpdateMeCommand, type User} from '@perfectpost/perfect-post-common';
import {useMutation, useQueryClient} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {sessionKeys} from '../keys';
import type {MutationUiOptions} from '../../../utils/mutationMeta';

/**
 * Modifie le profil (prénom, nom, e-mail).
 *
 * Remplace le thunk `updateProfile` de `src/store/mainslice.ts`, dont le reducer
 * recopiait la réponse dans `state.main.user`.
 */
export function useUpdateProfileMutation(options: MutationUiOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationKey: [...sessionKeys.mutations(), 'updateProfile'],
    mutationFn: ({firstname, lastname, email}: Partial<Pick<User, 'firstname' | 'lastname' | 'email'>>) =>
      sendOrThrow(new UpdateMeCommand({firstname, lastname, email})),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: sessionKeys.me()});
    },
  });
}
